import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Collapse from '@material-ui/core/Collapse';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Alert from '@material-ui/lab/Alert';
import MenuItem from '@material-ui/core/MenuItem';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Link from '@material-ui/core/Link';
import LinkIcon from '@material-ui/icons/Link';
import ListOfUsers from '../../components/ListOfUsers';
import DropZone from '../../components/DropZone';
import { XMEI_PRIMARY_COLOR } from '../../consts/common';
import { instanceAxios } from '../../InstanceAxios';
import StatusTribute from '../../components/StatusTribute';
import { formatMoney, formatDate2 } from '../../utils/common';
import HeadTable from '../../components/HeadTable';

function Tributos() {
  const useStyles = makeStyles((theme) => ({
    root: {
      overflow: 'auto',
      width: '100%',
    },
    paper: {
      position: 'absolute',
      width: 800,
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      top: `50%`,
      left: `50%`,
      transform: `translate(-50%, -50%)`,
      width: '80%',
      height: '80%',
      overflow: 'auto',
    },
    loading: {
      marginLeft: '50%',
    },
    selectTipo: {
      width: 200,
    },
    modalAddTitle: {
      position: 'absolute',
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 2),
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
  }));

  const hoje = new Date();
  const [columns, setColumns] = useState([
    { id: 'tipo', label: 'Tipo', minWidth: 70 },
    { id: 'data_vencimento', label: 'Data Vencimento', minWidth: 140 },
    { id: 'status', label: 'Status', minWidth: 140 },
    { id: 'valor_tributo', label: 'Valor Tributo', minWidth: 80 },
    { id: 'valor_multa', label: 'Valor Multa', minWidth: 140 },
    {
      id: 'valor_juros_encargos',
      label: 'Valor Juros/Encargos',
      minWidth: 140,
    },
    { id: 'valor_total', label: 'Valor Total', minWidth: 140 },
    { id: 'pdf', label: 'PDF', minWidth: 70 },
    { id: 'editar', label: '', minWidth: 70 },
  ]);
  const [meses, setMeses] = useState([
    { nome: 'JAN', valor: 1 },
    { nome: 'FEV', valor: 2 },
    { nome: 'MAR', valor: 3 },
    { nome: 'ABR', valor: 4 },
    { nome: 'MAI', valor: 5 },
    { nome: 'JUN', valor: 6 },
    { nome: 'JUL', valor: 7 },
    { nome: 'AGO', valor: 8 },
    { nome: 'SET', valor: 9 },
    { nome: 'OUT', valor: 10 },
    { nome: 'NOV', valor: 11 },
    { nome: 'DEZ', valor: 12 },
  ]);
  const [anos, setAnos] = useState([
    { nome: '2015', valor: 2015 },
    { nome: '2016', valor: 2016 },
    { nome: '2017', valor: 2017 },
    { nome: '2018', valor: 2018 },
    { nome: '2019', valor: 2019 },
    { nome: '2020', valor: 2020 },
    { nome: '2021', valor: 2021 },
  ]);
  const [openModal, setOpenModal] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [tipoAlert, setTipoAlert] = useState('');
  const [messageAlert, setMessageAlert] = useState('');
  const [ready, setReady] = useState(true);
  const [nomeUsuario, setNomeUsuario] = useState('');
  const [usuario, setUsuario] = useState(null);
  const [tributos, setTributos] = useState([]);
  const [tipo, setTipo] = useState('');
  const [status, setStatus] = useState('');
  const [dtVencimento, setDtVencimento] = useState('');
  const [mesRef, setMesRef] = useState('');
  const [anoRef, setAnoRef] = useState('');
  const [valorTributo, setValorTributo] = useState(0);
  const [valorMulta, setValorMulta] = useState(0);
  const [valorJurosEncargos, setValorJurosEncargos] = useState(0);
  const [valorTotal, setValorTotal] = useState(0);
  const [codigoBarra, setCodigoBarra] = useState('');
  const [mes, setMes] = useState(hoje.getMonth() + 1);
  const [ano, setAno] = useState(hoje.getFullYear());
  const [openModalAddFile, setOpenModalAddFile] = useState(false);
  const [fileSelect, setFileSelect] = useState(null);
  const [fileName, setFileName] = useState('');
  const [campoOrdenacao, setCampoOrdenacao] = useState('');
  const [ordem, setOrdem] = useState('');

  const clickAlert = () => {
    setOpenAlert(false);
    setTipoAlert('');
    setMessageAlert('');
  };

  const handleChangeUsuario = async (user) => {
    setUsuario(user);
    atualizarImpostos(user.id, mes, ano, campoOrdenacao, ordem);
  };

  const handleChangeMes = (event) => {
    setMes(event.target.value);
    if (usuario)
      atualizarImpostos(
        usuario.id,
        event.target.value,
        ano,
        campoOrdenacao,
        ordem
      );
  };

  const handleChangeAno = (event) => {
    setAno(event.target.value);
    if (usuario)
      atualizarImpostos(
        usuario.id,
        mes,
        event.target.value,
        campoOrdenacao,
        ordem
      );
  };

  const atualizarImpostos = async (id, m, a, co, o) => {
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/tributos/${id}?mes=${m}&ano=${a}&campoOrdenacao=${co}&ordem=${o}`)
      .then((res) => {
        setTributos(res.data);
        setReady(true);
      })
      .catch((err) => {
        console.log(err);
        setTributos([]);
        setReady(true);
      });
  };

  const salvarTributo = async () => {
    if (!isValidTributo()) {
      setTipoAlert('warning');
      setMessageAlert('Preencha Todos os Campos Necessários');
      setOpenAlert(true);
      return;
    }
    const data = new FormData();
    data.append('file', fileSelect);
    data.append('id_usuario', usuario.id);
    data.append('data_vencimento', dtVencimento);
    data.append('mes_referencia', mesRef);
    data.append('ano_referencia', anoRef);
    data.append('status', status);
    data.append('valor_tributo', valorTributo);
    data.append('valor_multa', valorMulta);
    data.append('valor_juros_encargos', valorJurosEncargos);
    data.append('valor_total', valorTotal);
    data.append('tipo', tipo);
    data.append('codigo_barra', codigoBarra);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .post(`/tributos`, data)
      .then((res) => {
        setOpenModalAddFile(false);
        setOpenAlert(true);
        setTipoAlert('success');
        setMessageAlert('Tributo Salvo com Sucesso!');
        clearData();
        setReady(true);
        setOpenModal(false);
      })
      .catch((err) => {
        console.log(err);
        setOpenModalAddFile(false);
        setOpenAlert(true);
        setTipoAlert('error');
        setMessageAlert(
          'Houve um erro de comunicação, verifique sua conexão e tente novamente mais tarde.'
        );
        clearData();
        setReady(true);
        setOpenModal(false);
      });
  };

  const clearData = () => {
    setUsuario(null);
    setNomeUsuario('');
    setFileSelect(null);
    setFileName('');
    clearTributo();
    setTributos([]);
  };

  const clearTributo = () => {
    setTipo('');
    setStatus('');
    setDtVencimento('');
    setMesRef('');
    setAnoRef('');
    setValorTributo(0);
    setValorMulta(0);
    setValorJurosEncargos(0);
    setValorTotal(0);
    setCodigoBarra('');
  };

  const setTributo = (tr) => {
    const dataVencimento = formatDate2(tr.data_vencimento);
    setTipo(tr.tipo);
    setStatus(tr.status);
    setDtVencimento(dataVencimento);
    setMesRef(tr.mes_referencia);
    setAnoRef(tr.ano_referencia);
    setValorTributo(tr.valor_tributo);
    setValorMulta(tr.valor_multa);
    setValorJurosEncargos(tr.valor_juros_encargos);
    setValorTotal(tr.valor_total);
    setCodigoBarra(tr.codigo_barra);
  };

  const isValidTributo = () => {
    if (
      !tipo ||
      !status ||
      !dtVencimento ||
      !mesRef ||
      !anoRef ||
      !valorTributo
    )
      return false;
    return true;
  };

  const excluirDas = async (tr) => {
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .delete(`/tributos/${tr.id}`)
      .then((res) => {
        const trbts = tributos.filter((t) => t.id !== tr.id);
        setTributos(trbts);
        setTipoAlert('success');
        setMessageAlert('Tributo Excluido com Sucesso!');
        setReady(true);
      })
      .catch((err) => {
        console.log(err);
        setTipoAlert('error');
        setMessageAlert('Erro ao excluir tributo!');
        setReady(true);
      });
  };

  const handleModal = (tr) => {
    if (!tr) {
      tr = {
        valor_tributo: 0,
        valor_multa: 0,
        valor_juros_encargos: 0,
        valor_total: 0,
      };
    }

    setTributo(tr);
    setOpenModal(true);
  };

  const closeModal = () => {
    clearData();
    setOpenModal(false);
  };

  const handleAddFile = (classes) => {
    return (
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={openModalAddFile}
        onClose={() => setOpenModalAddFile(false)}
      >
        <div className={classes.modalAddTitle}>
          <DropZone handleButtonClick={handleButtonClick} />
        </div>
      </Modal>
    );
  };

  const handleButtonClick = (file) => {
    setOpenModalAddFile(false);
    if (file) {
      setFileSelect(file[0]);
      setFileName(file[0].name);
    }
  };

  const handleCampoOrdenacao = (co) => {
    // Checando se Não é a coluna Editar
    if (co === 'pdf' || co === 'editar') return;

    let o;
    // Checando se é o mesmo atual
    if (co === campoOrdenacao) {
      o = ordem === 'asc' ? 'desc' : 'asc';
      setOrdem(o);
    } else {
      o = 'asc';
      setOrdem(o);
      setCampoOrdenacao(co);
    }

    atualizarImpostos(usuario.id, mes, ano, co, o);
  };

  const classes = useStyles();
  return (
    <>
      <h1>Tributos</h1>
      <Collapse in={openAlert}>
        <Alert severity={tipoAlert} onClick={clickAlert}>
          {messageAlert}
        </Alert>
      </Collapse>
      <Paper className={classes.root}>
        <Collapse in={ready === false}>
          <CircularProgress className={classes.loading} />
        </Collapse>
        <Collapse in={ready}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              padding: 10,
            }}
          >
            <Grid container>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <ListOfUsers
                  label="Nome do Cliente *"
                  width="40%"
                  userSelect={nomeUsuario}
                  setUserSelect={(user) => setNomeUsuario(user)}
                  setObjUser={(user) => handleChangeUsuario(user)}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div align="right">
                  <FormControl variant="outlined">
                    <InputLabel>Mês</InputLabel>
                    <Select value={mes} onChange={handleChangeMes} label="Mês">
                      {meses.map((m) => (
                        <MenuItem value={m.valor}>{m.nome}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl variant="outlined">
                    <InputLabel>Ano</InputLabel>
                    <Select value={ano} onChange={handleChangeAno} label="Ano">
                      {anos.map((a) => (
                        <MenuItem value={a.valor}>{a.nome}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Button
                  disabled={!usuario}
                  variant="outlined"
                  onClick={() => handleModal(null)}
                  style={{
                    backgroundColor: XMEI_PRIMARY_COLOR,
                    color: '#FFF',
                    marginTop: 30,
                    marginBottom: 10,
                  }}
                >
                  Adicionar
                </Button>
              </Grid>
            </Grid>
          </div>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <HeadTable
                order={ordem}
                idOrder={campoOrdenacao}
                columns={columns}
                setIdOrder={handleCampoOrdenacao}
              />
            </TableHead>
            <TableBody>
              {tributos.map((t) => {
                return (
                  <TableRow>
                    <TableCell component="th" scope="row">
                      {t.tipo}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {t.data_vencimento}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <StatusTribute status={t.status} />
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {formatMoney(t.valor_tributo)}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {formatMoney(t.valor_multa)}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {formatMoney(t.valor_juros_encargos)}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {formatMoney(t.valor_total)}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {t.url_pdf ? (
                        <Link href={t.url_pdf} target="_blank">
                          <LinkIcon />
                        </Link>
                      ) : null}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <IconButton
                        onClick={() => handleModal(t)}
                        style={{
                          color: XMEI_PRIMARY_COLOR,
                        }}
                        aria-label="Editar Tributo"
                      >
                        <EditIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <IconButton
                        aria-label="excluir"
                        onClick={() => excluirDas(t)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Collapse>
      </Paper>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={openModal}
        onClose={closeModal}
      >
        <div className={classes.paper}>
          <Grid container spacing={1} justify="left" alignItems="left">
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <h2 id="simple-modal-title">Tributo</h2>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Collapse in={openAlert}>
                <Alert severity={tipoAlert} onClick={clickAlert}>
                  {messageAlert}
                </Alert>
              </Collapse>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <TextField
                select
                required
                variant="outlined"
                label="Tipo"
                value={tipo}
                style={{ width: 200 }}
                onChange={(data) => setTipo(data.target.value)}
              >
                <MenuItem value="PIS">PIS</MenuItem>
                <MenuItem value="COFINS">COFINS</MenuItem>
                <MenuItem value="IRPJ">IRPJ</MenuItem>
                <MenuItem value="CSSL">CSSL</MenuItem>
                <MenuItem value="ISS">ISS</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <div align="right">
                <TextField
                  select
                  required
                  label="Status"
                  variant="outlined"
                  value={status}
                  style={{ width: 200 }}
                  onChange={(data) => setStatus(data.target.value)}
                >
                  <MenuItem value="A Vencer">A Vencer</MenuItem>
                  <MenuItem value="Liquidado">Liquidado</MenuItem>
                  <MenuItem value="Devedor">Devedor</MenuItem>
                  <MenuItem value="Em Parcelamento">Em Parcelamento</MenuItem>
                </TextField>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <TextField
                label="Vencimento"
                id="vencimento"
                required
                variant="outlined"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                value={dtVencimento}
                onChange={(data) => setDtVencimento(data.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <div align="right">
                <TextField
                  select
                  required
                  variant="outlined"
                  label="Mes"
                  style={{ width: 100 }}
                  value={mesRef}
                  onChange={(data) => setMesRef(data.target.value)}
                >
                  {meses.map((m) => (
                    <MenuItem value={m.valor}>{m.nome}</MenuItem>
                  ))}
                </TextField>
                <TextField
                  select
                  required
                  variant="outlined"
                  label="Ano"
                  style={{ width: 100 }}
                  value={anoRef}
                  onChange={(data) => setAnoRef(data.target.value)}
                >
                  {anos.map((a) => (
                    <MenuItem value={a.valor}>{a.nome}</MenuItem>
                  ))}
                </TextField>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <TextField
                label="Valor Tributo"
                type="number"
                required
                variant="outlined"
                value={valorTributo}
                onChange={(data) => {
                  setValorTributo(data.target.value);
                  setValorTotal(
                    Number(data.target.value) +
                      Number(valorMulta) +
                      Number(valorJurosEncargos)
                  );
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <TextField
                label="Valor Multa"
                type="number"
                required
                variant="outlined"
                value={valorMulta}
                onChange={(data) => {
                  setValorMulta(data.target.value);
                  setValorTotal(
                    Number(data.target.value) +
                      Number(valorTributo) +
                      Number(valorJurosEncargos)
                  );
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <TextField
                label="Valor Juros/Encargos"
                type="number"
                required
                variant="outlined"
                value={valorJurosEncargos}
                onChange={(data) => {
                  setValorJurosEncargos(data.target.value);
                  setValorTotal(
                    Number(data.target.value) +
                      Number(valorTributo) +
                      Number(valorMulta)
                  );
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <TextField
                label="Valor Total"
                type="number"
                required
                variant="outlined"
                value={valorTotal}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <TextField
                label="Código de Barra"
                value={codigoBarra}
                variant="outlined"
                fullWidth
                onChange={(data) => setCodigoBarra(data.target.value)}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1} justify="left" alignItems="left">
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Button
                startIcon={<CloudUploadIcon />}
                style={{
                  backgroundColor: XMEI_PRIMARY_COLOR,
                  color: '#FFF',
                  marginBottom: 10,
                  marginTop: '5%',
                }}
                color="primary"
                onClick={() => setOpenModalAddFile(true)}
              >
                {fileName || 'Enviar'}
              </Button>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <div align="right">
                <Button
                  style={{
                    backgroundColor: XMEI_PRIMARY_COLOR,
                    color: '#FFF',
                    marginBottom: 10,
                    marginTop: '5%',
                  }}
                  color="primary"
                  onClick={salvarTributo}
                >
                  Salvar
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </Modal>
      {handleAddFile(classes)}
    </>
  );
}

export default Tributos;
